<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue';
import { replaceGuillemets } from '../lib/guillemets';

const props = defineProps<{ modelValue: string; readonly: boolean }>();
const emit = defineEmits<{ 'update:modelValue': [value: string]; change: [] }>();
const editor = ref<HTMLElement | null>(null);

function syncText() {
  const element = editor.value;
  if (element && element.innerText !== props.modelValue) element.innerText = props.modelValue;
}

function moveCursorToEnd(element: HTMLElement) {
  const range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
}

function update(event: Event) {
  const element = event.currentTarget as HTMLElement;
  const next = replaceGuillemets(element.innerText);
  if (next !== element.innerText) {
    element.innerText = next;
    moveCursorToEnd(element);
  }
  emit('update:modelValue', next);
  emit('change');
}

onMounted(syncText);
watch(() => props.modelValue, () => void nextTick(syncText), { flush: 'post' });
</script>

<template>
  <div ref="editor" class="summary-input summary-editor ui-readable-copy" :contenteditable="!readonly" role="textbox" aria-multiline="true" aria-label="Kurzbeschreibung" :data-placeholder="readonly ? '' : 'Kurze Beschreibung hinzufügen …'" @input="update" />
</template>
